<template>
  <div class="container-import">
    <div class="background-modal"></div>
    <div class="content-modal" id="products-imports">
      <h2 class="text-center">Importar Productos</h2>

      <b-form-file
          class="mt-2"
          v-model="files"
          :state="Boolean(file)"
          :multiple="false"
          accept=".xlsx"
          placeholder="Seleccionar archivo en Excel"
          @change="upload($event.target.files)"
      >

      </b-form-file>

      <div v-show="file" class="text-center mt-2">
        <span>Una vez finalice la actualización de los productos <br> se notificara via correo electronico</span>
        <br>
        <base-button @click="close" class="mt-2" type="success">Aceptar</base-button>
      </div>
      <!--<div class="content-import">
        <vue-dropzone
            ref="dropzone"
            id="dropzone"
            @vdropzone-complete="success"
            :options="dropzoneOptions">
        </vue-dropzone>
        <button @click="removerArchivos">Remover Archivos</button>
      </div>-->
    </div>
  </div>
</template>
<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {product_service} from "@/services/product/ProductService";

export default {
  name: "ImportProduct",
  data() {
    return {
      file: false,
      files: []
    }
  },
  methods: {
    removerArchivos() {
      this.$refs.dropzone.removeAllFiles();
    },
    success(file) {
      console.log(file)
      product_service.ImportProducts(file)
    },
    upload: function (files) {
      this.file =  true
      product_service.ImportProducts(files)
    },
    close(){
      document.getElementsByClassName('container-import')[0].style.display = 'none';
    }
  }
}
</script>
<style scoped>
.container-import {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  right: 0;
  bottom: 0;
  display: none;
}

.content-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: max-content;
  height: 10em;
  margin: auto;
  z-index: 200;
}

.background-modal {
  background-color: lightgray;
  opacity: 0.8;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}

label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}
.custom-file-input:lang(es) ~ .custom-file-label::after {
  content: 'Buscar';
}
</style>